import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Moma Design Studio
 * id FE245F0F-24CE-497E-BA73-19936BD14716
 * name cellphone-charging
 * version: 5.0.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cellphone-charging.svg
 * tags
 * - Cellphone / Phone 
 */
export const CellphoneChargingIcon = createSvgIcon(<><path d="M11 18.5V13H9L13 5.5V11H15M17 19H7V5H17M17 1H7C5.89 1 5 1.89 5 3V21A2 2 0 0 0 7 23H17A2 2 0 0 0 19 21V3C19 1.89 18.1 1 17 1Z" /></>, 'CellphoneChargingIcon');
export default CellphoneChargingIcon